import React from 'react';
import { useTranslation } from 'react-i18next';
import HeavyRainContent from './HeavyRainContent';
import HistoricMonumentsContent from './HistoricMonumentsContent';
import ZonesSurveilleesContent from './ZonesSurveilleesContent';
import ArretePerilsContent from './ArretePerilsContent';
import FireStationContent from './FireStationContent';
import GasStationContent from './GasStationContent';

export type PanelContentType = 'heavyRain' | 'historicMonuments' | 'zonesSurveillees' | 'arretePerils' | 'fireStation' | 'gasStation' | null;

interface SidePanelProps {
  isOpen: boolean;
  contentType: PanelContentType;
  onClose: () => void;
  width?: string;
  // Props pour les différents types de contenu
  heavyRainFeature?: {date: string, [key: string]: unknown} | null;
  historicMonuments?: any[];
  zonesSurveillees?: any[];
  arretePerils?: any[];
  fireStation?: any;
  gasStation?: any;
}

const SidePanel: React.FC<SidePanelProps> = ({ 
  isOpen, 
  contentType,
  onClose, 
  width = '350px',
  heavyRainFeature,
  historicMonuments,
  zonesSurveillees,
  arretePerils,
  fireStation,
  gasStation
}) => {
  const { t } = useTranslation();
  if (!isOpen || !contentType) return null;

  const getTitle = () => {
    switch (contentType) {
      case 'heavyRain':
        return 'PLUIE INTENSE';
      case 'historicMonuments':
        return 'MONUMENTS HISTORIQUES';
      case 'zonesSurveillees':
        return 'ZONES SURVEILLÉES';
      case 'arretePerils':
        return 'ARRETE PERILS';
      case 'fireStation':
        return t("fireStation.panelTitle");
      case 'gasStation':
        return t("gasStation.panelTitle");
      default:
        return '';
    }
  };

  const renderContent = () => {
    switch (contentType) {
      case 'heavyRain':
        return <HeavyRainContent feature={heavyRainFeature || null} />;
      case 'historicMonuments':
        return <HistoricMonumentsContent monuments={historicMonuments || []} />;
      case 'zonesSurveillees':
        return <ZonesSurveilleesContent zones={zonesSurveillees || []} />;
      case 'arretePerils':
        return <ArretePerilsContent features={arretePerils || []} />;
      case 'fireStation':
        return <FireStationContent fireStation={fireStation} />;
      case 'gasStation':
        return <GasStationContent gasStation={gasStation} />;
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        right: isOpen ? 0 : `-${width}`,
        width,
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.98)',
        backdropFilter: 'blur(10px)',
        boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
        borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'auto',
        zIndex: 1000,
        transition: 'right 0.3s ease-in-out',
        overflowY: 'auto',
      }}
    >
      <div style={{ padding: '20px', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h6 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }}>
            {getTitle()}
          </h6>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              padding: 0,
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666',
              borderRadius: '50%',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            ×
          </button>
        </div>
      </div>
      <div style={{ padding: '20px', fontSize: '14px', color: '#333', flex: 1 }}>
        {renderContent()}
      </div>
    </div>
  );
};

export default SidePanel;
